import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { LoginForm } from "../../components/LoginForm";

/**
 * Public sign-in page. Redirects already authenticated users to /jobs and
 * delegates credential handling to the auth context via {@link LoginForm}.
 */
export function LoginPage() {
  const { login, status, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  // Portal users land on /portal; vendor roles on the board.
  const home = user?.systemRole === "client" ? "/portal" : user?.permissions.some((permission) => permission === "*" || permission === "jobs.read") ? "/jobs" : "/account";

  useEffect(() => {
    if (status === "authenticated") navigate(home, { replace: true });
  }, [status, home, navigate]);

  const handleSubmit = async (email: string, password: string): Promise<void> => {
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <LoginForm onSubmit={handleSubmit} error={error} submitting={submitting} />
    </div>
  );
}
